import { render } from "./AppClickAway.vue?vue&type=template&id=16c4d813&ts=true"
import script from "./AppClickAway.vue?vue&type=script&lang=ts"
export * from "./AppClickAway.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__